import type { RoleInfo } from '../types/review';

export const reviewRoles: RoleInfo[] = [
  { role: 'ডাটা রিভিউ অপারেটর', user: 'মোঃ রফিকুল ইসলাম', designation: 'ডাটা রিভিউ অপারেটর, ট্রাফিক বিভাগ' },
  { role: 'যাচাই কর্মকর্তা', user: 'মোঃ শফিকুল ইসলাম', designation: 'ইন্সপেক্টর (ট্রাফিক), যাচাই সেল' },
  { role: 'অনুমোদনকারী কর্মকর্তা', user: 'মোঃ কামরুল হাসান', designation: 'অতিরিক্ত উপ-পুলিশ কমিশনার (ট্রাফিক)' },
  { role: 'স্টিকার অপারেটর', user: 'মোঃ সাজ্জাদ হোসেন', designation: 'QR স্টিকার অপারেটর' },
  { role: 'সুপার অ্যাডমিন', user: 'মোঃ আতিকুর রহমান', designation: 'সিস্টেম অ্যাডমিনিস্ট্রেটর' }
];

export const roleDuties: Record<string, string> = {
  'ডাটা রিভিউ অপারেটর': 'আবেদনের পূর্ণতা ও ডকুমেন্ট পর্যালোচনা • অনুমোদন করতে পারেন না',
  'যাচাই কর্মকর্তা': 'মালিক, গাড়ি ও BRTA তথ্য যাচাই • চূড়ান্ত অনুমোদন করতে পারেন না',
  'অনুমোদনকারী কর্মকর্তা': 'অনুমোদন, সংশোধনে ফেরত বা বাতিল',
  'স্টিকার অপারেটর': 'কেবল অনুমোদিত গাড়ির স্টিকার প্রক্রিয়া',
  'সুপার অ্যাডমিন': 'রোল ও ওয়ার্কফ্লো কনফিগারেশন'
};

export const validationOfficers = ['মোঃ শফিকুল ইসলাম', 'মোছাঃ ফারজানা ইয়াসমিন', 'মোঃ জাহিদুল হক', 'মোঃ রফিকুল ইসলাম'];

export const trafficDivisions = ['মিরপুর', 'তেজগাঁও', 'গুলশান', 'রমনা', 'উত্তরা', 'মোহাম্মদপুর', 'মতিঝিল', 'ওয়ারী', 'লালবাগ'];

export const ownerChecklist = ['নাম যাচাই করা হয়েছে', 'NID তথ্য যাচাই করা হয়েছে', 'মোবাইল নম্বর যাচাইকৃত', 'মালিকানার তথ্য যাচাই করা হয়েছে', 'ডকুমেন্ট পাঠযোগ্য'];

export const cngVehicleChecklist = ['রেজিস্ট্রেশন নম্বর সঠিক', 'চেসিস নম্বর সঠিক', 'ইঞ্জিন নম্বর সঠিক', 'গাড়ির ধরন সঠিক', 'ফিটনেস তথ্য যাচাই', 'ট্যাক্স টোকেন যাচাই', 'রুট পারমিট যাচাই (প্রযোজ্য হলে)'];
export const mclVehicleChecklist = ['রেজিস্ট্রেশন নম্বর সঠিক', 'চেসিস নম্বর সঠিক', 'ইঞ্জিন নম্বর সঠিক', 'গাড়ির ধরন সঠিক', 'ট্যাক্স টোকেন যাচাই'];

export const correctionReasons = [
  'মালিকের তথ্যের অমিল',
  'NID তথ্যের অমিল',
  'গাড়ির রেজিস্ট্রেশন তথ্যের অমিল',
  'চেসিস/ইঞ্জিন নম্বরের অমিল',
  'ডকুমেন্ট অস্পষ্ট',
  'ডকুমেন্ট মেয়াদোত্তীর্ণ',
  'BRTA তথ্যের অমিল',
  'অন্যান্য'
];

export const rejectionReasons = [
  'আবেদনকারী গাড়ির বৈধ মালিক নন',
  'ভুয়া/জাল ডকুমেন্ট',
  'ডুপ্লিকেট আবেদন',
  'BRTA রেকর্ডে গাড়ির তথ্য পাওয়া যায়নি',
  'নির্ধারিত সময়ে সংশোধন জমা দেওয়া হয়নি',
  'অন্যান্য'
];

/** Simulated BRTA owner of record per registration number (prototype sample). */
export const brtaOwners: Record<string, string> = {
  'ঢাকা-থ-১১-১২৩৪': 'মোঃ রহিম উদ্দিন',
  'ঢাকা মেট্রো-ল-৪৫-৬৭৮৯': 'মোঃ রহিম উদ্দিন'
};

/** Field that differs from the simulated BRTA record for sample mismatch applications. */
export const brtaMismatchFields: Record<string, string> = {
  'DMP-OWN-2026-000127': 'চেসিস নম্বর',
  'DMP-OWN-2026-000102': 'ইঞ্জিন নম্বর'
};

export const kpiBase = { total: 1250, new: 128, processing: 215, awaiting: 105, approved: 680, returned: 85, rejected: 37, cng: 850, mcl: 400 };

export const reviewWorkflow = [
  { role: 'গাড়ির মালিক', task: 'মোবাইল অ্যাপে আবেদন জমা' },
  { role: 'ডাটা রিভিউ অপারেটর', task: 'পূর্ণতা ও ডকুমেন্ট পর্যালোচনা' },
  { role: 'যাচাই কর্মকর্তা', task: 'মালিক, গাড়ি ও BRTA যাচাই' },
  { role: 'অনুমোদনকারী কর্মকর্তা', task: 'অনুমোদন / ফেরত / বাতিল' },
  { role: 'স্টিকার অপারেটর', task: 'QR স্টিকার তৈরি ও ইস্যু' },
  { role: 'গাড়ির মালিক', task: 'নোটিফিকেশন ও স্টিকার ট্র্যাকিং' }
];
